module.exports = __webpack_public_path__ + "img/soccerboard49.b0372d64.jpg";